import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import { Context } from "../context";
import uniqid from "uniqid";
import { getImage, getDataById, minToHours, getDataByUniq } from "./utils";

export function PlaylistInner({ history, match, playlistId }) {
  const [expanded, setExpanded] = useState(true);

  const context = useContext(Context);

  const filterVideos = (playlistId, app, user) => {

  }

  return (
    <>
      {/* <div
      className={`l_playlist ${expanded ? "l_playlist--md" : "l_playlist--"}`}
    > */}
      {/* <div className="h0">
        <div
          className="ui_tabs ui_tabs--expandable"
          onClick={() => setExpanded(!expanded)}
        >
          <div className="ui_tabs__ul">
            <div className="ui_tabs__li">
              <div className="ui_tabs__menu_item ui_tabs__menu_item--header">
                <div>Streams</div>
                <div className="m_ico m_ico--rotate">
                  {!expanded && <div>unfold_more</div>}
                  {expanded && <div>unfold_less</div>}
                </div>
              </div>
            </div>
            <div className="ui_tabs__li ui_tabs__li--right"></div>
          </div>
        </div>
      </div> */}


      <div className="l_thumbs_day">
        <div className="l_thumbs_ul">
          {context.data["videos"]
          .filter(one => {
            return one['playlists'].includes(playlistId)
          })
          .map((one) => {
            return (
              <PlaylistItem
                active={match["params"]["videoId"] === one["id"]}
                {...one}
              />
            );
          })}
        </div>
      </div>
      {/* </div> */}
    </>
  );
}

function PlaylistItemInner(props) {
  const context = useContext(Context);
  const {
    active,
    id,
    uniq,
    url,
    img,
    title,
    date,
    length,
    user,
    userImg,
    app,
    comments,
    history,
    match,
  } = { ...props };

  const handleClick = () => {
    history.push(`/list/${match.params["playlistId"]}/${id}`);
  };
  console.log(getDataById(context, "apps", app, "url"));
  console.log("app", app);

  return (
    <div className="l_thumbs_li" onClick={() => handleClick()}>
      <div className={`ui_video_element ${active ? "active" : ""}`}>
        <div className="p_thumbs_ava">
          {/* <img
            src={getImage(userImg)}
            loading="lazy"
            alt
            className="p_user_ava_img"
          /> */}

          {/* {getDataById(context, 'apps', app, 'url')} */}
          <img
            src={getImage(getDataById(context, "apps", app, "url"))}
            loading="lazy"
            alt
            className="p_user_ava_img"
          />
        </div>
        <div className="l_thumbs_vid" style={{ backgroundColor: "#cccccc12" }}>
          <div className="ui_video_element_timestamp">{minToHours(length)}</div>
          <img src={getImage(img, "full")} loading="lazy" sizes="100px" />
        </div>
        <div className="ui_video_element_info">
          <div href="#" className="ui_video_element_info_text">
            <div>
              <div className="x_comment_text x_comment_text--mini">
                {/* {getDataById(context, 'comments', comments[0], 'commentText')} */}
                {title}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


export function PlaylistTop({
  id,
  img,
  title,
  user,
  color,
  emoji,
  icon,
  size
}) {
  const context = useContext(Context);

  // const { id, img, title, user, color, emoji, icon } = getDataByUniq(context, "playlists", playlistId) || getDataById(context, "playlists", "default");

  return (
    <>
      <div className={`x_cover0 ${size === 'sm' ? 'x_cover0--sm' : ''}`}>
        <div
          className="x_header_pic"
          style={{
            backgroundImage: `linear-gradient(180deg, rgba(6, 161, 154, 0.7), rgba(6, 161, 154, 0.7)), url("${getImage(
              img,
              "large"
            )}")`,
          }}
        />
        <div className="x_cover_content">
          <div className="x_cover_title0">
            <div className="x_cover_h1">
              <div className="x_cover_emoji">
                {Boolean(emoji) && <div className="m_ico">{emoji}</div>}
                {Boolean(icon) && <div className="m_ico">{icon}</div>}
              </div>
              <div className="x_cover_title">{title}</div>
            </div>
            <div className="x_cover_h2">
              <div className="x_cover_createdby">Created by: </div>
              <div className="x_user">
                <div className="x_user_ava">
                  <img
                    src="https://assets.website-files.com/61785133118e574036320746/6178c2817f2e698567910a6e_ava.png"
                    loading="lazy"
                    sizes="(max-width: 767px) 16px, (max-width: 991px) 2vw, (max-width: 1919px) 16px, 1vw"
                    srcSet="https://assets.website-files.com/61785133118e574036320746/6178c2817f2e698567910a6e_ava-p-500.png 500w, https://assets.website-files.com/61785133118e574036320746/6178c2817f2e698567910a6e_ava.png 683w"
                    alt
                    className="p_user_ava_img p_user_ava_img--sm"
                  />
                </div>
                <div>
                  <span>Misha Miroshnikov</span>
                </div>
              </div>
            </div>
            <div className="x_cover_h2">
              <div className="x_cover_createdby">Contributors: </div>
              <div className="x_user">
                <div className="x_user_ava">
                  <img
                    src="https://assets.website-files.com/61785133118e574036320746/6178c2817f2e698567910a6e_ava.png"
                    loading="lazy"
                    sizes="(max-width: 767px) 16px, (max-width: 991px) 2vw, (max-width: 1919px) 16px, 1vw"
                    srcSet="https://assets.website-files.com/61785133118e574036320746/6178c2817f2e698567910a6e_ava-p-500.png 500w, https://assets.website-files.com/61785133118e574036320746/6178c2817f2e698567910a6e_ava.png 683w"
                    alt
                    className="p_user_ava_img p_user_ava_img--sm"
                  />
                </div>
                <div>
                  <span>Misha Miroshnikov</span>
                </div>
              </div>
            </div>
          </div>
          <div />
        </div>
      </div>
    </>
  );
}



export const PlaylistItem = withRouter(PlaylistItemInner);
export const Playlist = withRouter(PlaylistInner);